var map = {
	"./afs-global/logo.png": 6144,
	"./afwuk/logo.png": 3422,
	"./atlaslogistics/logo.png": 2490,
	"./atlaslogistics/slingco/logo.png": 2398,
	"./blank_fallback_logo/logo.png": 4335,
	"./extrordinair/logo.png": 1979,
	"./freightbox/logo.png": 3026,
	"./hwfs247/logo.png": 6395,
	"./kranlee/AMBLIMIT/logo.png": 4266,
	"./kranlee/FORB0001/logo.png": 8305,
	"./kranlee/FORBOFLO/logo.png": 505,
	"./kranlee/NORTHERN/logo.png": 6187,
	"./kranlee/ROBERLIM/logo.png": 767,
	"./kranlee/SCHENCKP/logo.png": 2032,
	"./kranlee/SPEEDPLA/logo.png": 4923,
	"./kranlee/TAYLORSE/logo.png": 5490,
	"./kranlee/TTSPRECI/logo.png": 7631,
	"./kranlee/intocast/logo.png": 2532,
	"./kranlee/logo.png": 9390,
	"./kranlee/shculcem/logo.png": 4529,
	"./kranlee/unipartr/logo.png": 5961,
	"./logicall/logo.png": 33,
	"./map/legacy/logo.png": 7784,
	"./map/logo.png": 9544,
	"./otds/logo.png": 2882,
	"./pfs/logo.png": 1409,
	"./qcs/logo.png": 6671,
	"./sandforduk/logo.png": 859,
	"./webtest/andysana/logo.png": 9882,
	"./webtest/logo.png": 9264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7497;